/* eslint-disable prefer-arrow-callback, no-plusplus, no-continue, no-restricted-syntax */
import { Snackbar, Alert } from "@mui/material";
import PropTypes from "prop-types";
import MDBox from "theme/components/MDBox";
import MDInput from "theme/components/MDInput";
import { useState, useEffect } from "react";

function CalculatedValueField({ displayName, fieldRef, options }) {
  const [fieldError, showFieldError] = useState(false);
  const [errMsg, setErrMsg] = useState("Invalid entry provided.");

  const [number, setNumber] = useState(null);
  const [formattedNumber, setFormattedNumber] = useState("");

  function calculateValue() {
    const elems = options.fields;
    if (elems.length <= 0) {
      setErrMsg(`${displayName} missing calculation fields.`);
      showFieldError(true);
      return;
    }

    const elemValues = [];
    for (let i = 0; i < elems.length; i++) {
      const id = elems[i];
      // console.log(id);
      const e = document.getElementById(`dff_${id}`);
      if (typeof e === "undefined") {
        // console.log("undefined");
        return;
      }

      const elemValue = e.value;
      const isnum = /^[0-9]\d*(\.\d+)?$/.test(elemValue);
      if (!isnum) {
        // console.log("not num");
        return;
      }

      const numValue = parseFloat(elemValue, 10);
      // console.log(numValue);
      elemValues.push(numValue);
    }

    // console.log(elemValues);
    if (elemValues.length <= 0) {
      return;
    }

    let finalValue = 0;
    for (let j = 0; j < elemValues.length; j++) {
      if (j === 0) {
        finalValue = elemValues[j];
        continue;
      }

      if (options.operator === "sum") {
        finalValue += elemValues[j];
      } else if (options.operator === "difference") {
        finalValue -= elemValues[j];
      } else if (options.operator === "product") {
        finalValue *= elemValues[j];
      } else if (options.operator === "quotient") {
        finalValue /= elemValues[j];
      } else if (options.operator === "percentage") {
        finalValue = ((finalValue / elemValues[j]) * 100).toFixed(2);
      } else {
        finalValue += elemValues[j];
      }
    }

    console.log(finalValue);

    setNumber(finalValue);
    const fNum = finalValue.toLocaleString("en");
    setFormattedNumber(fNum);
  }

  const form = document.getElementById("dataForm");
  form.addEventListener("change", function () {
    setTimeout(calculateValue, 1000);
  });

  useEffect(() => {
    if (number === null) {
      return;
    }

    const watchField = document.getElementById(`dff_${fieldRef}`);
    watchField.dispatchEvent(new Event("change"));
  }, [number]);

  return (
    <MDBox>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={5000}
        onClose={() => showFieldError(false)}
        open={fieldError}
      >
        <Alert severity="error" sx={{ width: "100%" }}>
          {errMsg}
        </Alert>
      </Snackbar>
      <MDInput
        margin="dense"
        label={displayName}
        value={formattedNumber}
        type="text"
        inputProps={{ readOnly: true, disabled: true }}
        InputLabelProps={{
          sx: {
            whiteSpace: 'break-spaces',
          },
        }}
        fullWidth
        variant="outlined"
        disabled
      />
      <input type="hidden" id={`dff_${fieldRef}`} name={fieldRef} value={number} />
    </MDBox>
  );
}

// Typechecking props of the Transaction
CalculatedValueField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

CalculatedValueField.defaultProps = {
  options: null,
};

export default CalculatedValueField;
